export default __webpack_public_path__ + "static/media/laval19.52749954.jpg";